import { Grid } from '@mui/material';

import { Dispatch } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import { AnyAction } from 'redux';

import { IFilterKeyValue } from 'common/api/type-def';
import { MODULES } from 'common/constants';
import {
	FILTER_NAME,
	FILTER_TYPE,
	PROGRESS_BAR_ELEMENTS,
} from 'common/constants/CitationDetails';
import {
	REGULATION_TAB_VALUES,
	REG_INV_CARD_NAMES,
	REG_INV_CARD_TYPE,
	REG_INV_FILTER_NAME,
} from 'common/constants/RegulationInventoryConstants';
import { rrcpDashboardRoutes } from 'common/constants/rrcp-dashboard-routes';
import storageWrapper from 'common/loginUtils/storage-wrapper';
import { RootState } from 'common/store/AppStore';
import { setRequirementInventoryBreadcrumbText } from 'common/store/reducer/commonReducer';
import {
	setRegInvLandingSelectedTab,
	setRegInventoryAppliedFilters,
} from 'common/store/reducer/regulationInventoryReducer';
import { urlWithTenant } from 'common/utils/utilFunctions';

import InventoryCard from 'features/RegulationInventory/Components/InventoryCard/InventoryCard';
import {
	currentInventoryCardDetails,
	guidanceIssuaunceTypes,
	industryIssuanceTypes,
	lawIssuanceTypes,
	regulationIssuanceTypes,
} from 'features/RegulationInventory/RegInventoryUtils';

import styles from './CurrentInventory.module.scss';

const { CURRENT_INVENTORY } = REGULATION_TAB_VALUES;

const { INVENTORY } = REG_INV_CARD_TYPE;

const {
	NOTSTARTED,
	APPLICABILITY_ASSESSMENT,
	APPLICABILITY_REVIEW,
	GROUPING_ASSESSMENT,
	GROUPING_REVIEW,
	SUMMARY_ASSESSMENT,
	SUMMARY_REVIEW,
	MAPPING_ASSESSMENT,
	MAPPING_REVIEW,
	COMPLETE,
} = PROGRESS_BAR_ELEMENTS;

const { INTERNATIONA_NAME, FEDERAL_STATES_NAME } = FILTER_NAME;

const { JURISDICTION_TYPE, ISSUANCE_TYPE, WORK_FLOW_STATUS_TYPE } = FILTER_TYPE;

const {
	FEDERAL_REGULATIONS,
	STATE_REGULATIONS,
	INTERNATIONAL_REGULATIONS,
	FEDERAL_LAWS,
	STATE_LAWS,
	INTERNATIONAL_LAW,
	FEDERAL_GUIDANCE,
	STATE_GUIDANCE,
	INTERNATIONAL_GUIDANCE,
	INDUSTRY_GUIDANCE,
} = REG_INV_CARD_NAMES;

const { US_FEDERAL, US_STATES, INTERNATIONAL } = REG_INV_FILTER_NAME;

const { regulationInventory, overView } = rrcpDashboardRoutes;

const addWorkFlowStatusFilter = (
	filters: IFilterKeyValue[],
	currentTab: string,
) => {
	if (currentTab === CURRENT_INVENTORY) {
		filters = [
			...filters,
			{
				key: WORK_FLOW_STATUS_TYPE,
				values: [COMPLETE],
			},
		];
	} else {
		filters = [
			...filters,
			{
				key: WORK_FLOW_STATUS_TYPE,
				values: [
					NOTSTARTED,
					APPLICABILITY_ASSESSMENT,
					APPLICABILITY_REVIEW,
					GROUPING_ASSESSMENT,
					GROUPING_REVIEW,
					SUMMARY_ASSESSMENT,
					SUMMARY_REVIEW,
					MAPPING_ASSESSMENT,
					MAPPING_REVIEW,
				],
			},
		];
	}
	return filters;
};

const setReduxFilterState = (
	filters: IFilterKeyValue[],
	dispatchValue: Dispatch<AnyAction>,
	currentTab: string,
) => {
	filters = addWorkFlowStatusFilter(filters, currentTab);
	dispatchValue(setRegInventoryAppliedFilters(filters));
};

export const setFilters = (
	title: string,
	dispatchValue: Dispatch<AnyAction>,
	currentTab: string,
) => {
	switch (title) {
		case FEDERAL_REGULATIONS: {
			const filters: IFilterKeyValue[] = [
				{
					key: JURISDICTION_TYPE,
					name: FEDERAL_STATES_NAME,
					values: [US_FEDERAL],
				},
				{
					key: ISSUANCE_TYPE,
					values: regulationIssuanceTypes,
				},
			];
			setReduxFilterState(filters, dispatchValue, currentTab);
			break;
		}
		case STATE_REGULATIONS: {
			const filters: IFilterKeyValue[] = [
				{
					key: JURISDICTION_TYPE,
					name: FEDERAL_STATES_NAME,
					values: [US_STATES],
				},
				{
					key: ISSUANCE_TYPE,
					values: regulationIssuanceTypes,
				},
			];
			setReduxFilterState(filters, dispatchValue, currentTab);
			break;
		}
		case INTERNATIONAL_REGULATIONS: {
			const filters: IFilterKeyValue[] = [
				{
					key: JURISDICTION_TYPE,
					name: INTERNATIONA_NAME,
					values: [INTERNATIONAL],
				},
				{
					key: ISSUANCE_TYPE,
					values: regulationIssuanceTypes,
				},
			];
			setReduxFilterState(filters, dispatchValue, currentTab);
			break;
		}
		case FEDERAL_LAWS: {
			const filters: IFilterKeyValue[] = [
				{
					key: JURISDICTION_TYPE,
					name: FEDERAL_STATES_NAME,
					values: [US_FEDERAL],
				},
				{
					key: ISSUANCE_TYPE,
					values: lawIssuanceTypes,
				},
			];
			setReduxFilterState(filters, dispatchValue, currentTab);
			break;
		}
		case STATE_LAWS: {
			const filters: IFilterKeyValue[] = [
				{
					key: JURISDICTION_TYPE,
					name: FEDERAL_STATES_NAME,
					values: [US_STATES],
				},
				{
					key: ISSUANCE_TYPE,
					values: lawIssuanceTypes,
				},
			];
			setReduxFilterState(filters, dispatchValue, currentTab);
			break;
		}
		case INTERNATIONAL_LAW: {
			const filters: IFilterKeyValue[] = [
				{
					key: JURISDICTION_TYPE,
					name: INTERNATIONA_NAME,
					values: [INTERNATIONAL],
				},
				{
					key: ISSUANCE_TYPE,
					values: lawIssuanceTypes,
				},
			];
			setReduxFilterState(filters, dispatchValue, currentTab);
			break;
		}
		case FEDERAL_GUIDANCE: {
			const filters: IFilterKeyValue[] = [
				{
					key: JURISDICTION_TYPE,
					name: FEDERAL_STATES_NAME,
					values: [US_FEDERAL],
				},
				{
					key: ISSUANCE_TYPE,
					values: guidanceIssuaunceTypes,
				},
			];
			setReduxFilterState(filters, dispatchValue, currentTab);
			break;
		}
		case STATE_GUIDANCE: {
			const filters: IFilterKeyValue[] = [
				{
					key: JURISDICTION_TYPE,
					name: FEDERAL_STATES_NAME,
					values: [US_STATES],
				},
				{
					key: ISSUANCE_TYPE,
					values: guidanceIssuaunceTypes,
				},
			];
			setReduxFilterState(filters, dispatchValue, currentTab);
			break;
		}
		case INTERNATIONAL_GUIDANCE: {
			const filters: IFilterKeyValue[] = [
				{
					key: JURISDICTION_TYPE,
					name: INTERNATIONA_NAME,
					values: [INTERNATIONAL],
				},
				{
					key: ISSUANCE_TYPE,
					values: guidanceIssuaunceTypes,
				},
			];
			setReduxFilterState(filters, dispatchValue, currentTab);
			break;
		}
		case INDUSTRY_GUIDANCE: {
			const filters: IFilterKeyValue[] = [
				{
					key: ISSUANCE_TYPE,
					values: industryIssuanceTypes,
				},
			];
			setReduxFilterState(filters, dispatchValue, currentTab);
			break;
		}
		default:
			break;
	}
};

const CurrentInventory = () => {
	const loggedInUser = useSelector(
		(state: RootState) => state.common.loggedInUser,
	);

	const cardDetails = currentInventoryCardDetails(loggedInUser?.userId || '');

	const navigate = useNavigate();
	const dispatch = useDispatch();

	const cardClickHandler = (title: string) => {
		dispatch(setRegInvLandingSelectedTab(CURRENT_INVENTORY));

		dispatch(
			setRequirementInventoryBreadcrumbText(MODULES.REQUIREMENT_INVENTORY),
		);
		setCurrentInventoryFilter(title);
		storageWrapper.setStorageItem('selectedCardDetails', {
			selectedCardName: title,
			selectedRegInvLandingTab: CURRENT_INVENTORY,
			selectedTab: 5,
		});
		navigate(urlWithTenant(`/${regulationInventory}/${overView}`));
	};

	const setCurrentInventoryFilter = (title: string) => {
		setFilters(title, dispatch, CURRENT_INVENTORY);
	};

	return (
		<Grid container>
			{cardDetails.map((category: any) => (
				<Grid
					key={category.title}
					item
					xs={12}
					sm={4}
					md={4}
					lg={4}
					xl={4}
					className={styles['card-content']}
					spacing={2}
				>
					<InventoryCard
						key={category.title}
						apiHeaders={category.headers}
						cardType={INVENTORY}
						title={category.title}
						handleClick={() => cardClickHandler(category.title)}
					/>
				</Grid>
			))}
		</Grid>
	);
};

export default CurrentInventory;
